import React, { Component } from 'react';

class Work extends Component {
    render() {
        return (
            <section className="pt-0">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-12 col-md-10 col-lg-8 text-center">
                            <h2 className="mb-3">Trusted Across Industries</h2>
                            <p className="lead">From fintech to healthcare, organizations worldwide rely on Nafsi for secure, compliant identity verification</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="p-4 border rounded hover-translate">
                                <i className="la la-university ic-3x text-primary mb-3"></i>
                                <h5>Financial Services & Banking</h5>
                                <p className="mb-0">Meet KYC/AML requirements with fast, accurate customer onboarding and ongoing monitoring</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="p-4 border rounded hover-translate">
                                <i className="la la-btc ic-3x text-primary mb-3"></i>
                                <h5>Cryptocurrency & Web3</h5>
                                <p className="mb-0">Secure user verification for exchanges, wallets, and DeFi platforms with real-time fraud detection</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="p-4 border rounded hover-translate">
                                <i className="la la-heartbeat ic-3x text-primary mb-3"></i>
                                <h5>Healthcare & Telemedicine</h5>
                                <p className="mb-0">HIPAA-compliant patient verification for telehealth platforms and healthcare providers</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="p-4 border rounded hover-translate">
                                <i className="la la-shopping-cart ic-3x text-primary mb-3"></i>
                                <h5>E-Commerce & Marketplaces</h5>
                                <p className="mb-0">Reduce fraud and chargebacks with verified buyer and seller identities</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="p-4 border rounded hover-translate">
                                <i className="la la-car ic-3x text-primary mb-3"></i>
                                <h5>Ride-Sharing & Mobility</h5>
                                <p className="mb-0">Verify drivers and riders for safe, trusted transportation services</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="p-4 border rounded hover-translate">
                                <i className="la la-building ic-3x text-primary mb-3"></i>
                                <h5>Real Estate & PropTech</h5>
                                <p className="mb-0">Streamline tenant screening and property transactions with digital verification</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Work;